import React, { useState } from 'react';
import Icon from './Icon';

const ORDERS = [
  { no: 512, name: 'Priya S.', src: 'Phone', items: 'Chicken Biryani, Mango Lassi', total: '$23.17', status: 'New' },
  { no: 511, name: 'Table 4', src: 'Kiosk', items: '2× Butter Chicken, 4× Naan', total: '$58.40', status: 'Paid' },
  { no: 510, name: 'Marco R.', src: 'Phone', items: '3× Tacos al Pastor, Horchata', total: '$17.52', status: 'Ready' },
  { no: 509, name: 'Harpreet K.', src: 'Web', items: 'Sarson da Saag, Lassi', total: '$29.11', status: 'Done' },
];

const INITIAL_MENU = [
  { name: 'Goat Biryani', note: 'Daily', on: false },
  { name: 'Mutton Dum Biryani', note: 'Sat · Sun', on: true },
  { name: 'Paneer Tikka', note: 'Daily', on: true },
];

const FEATURES = [
  ['dashboard', 'Every order, one screen', 'Phone, kiosk and web orders appear live with their source, items and status.'],
  ['tag', 'One-tap sold out', 'Mark a dish unavailable and the phone AI, kiosk and website all stop offering it.'],
  ['calendar', 'Day-of-week dishes', 'Weekend-only specials appear on their days and are hidden the rest of the week.'],
  ['clock', 'Hours and pickup times', 'Set opening hours and ready-time ranges, and choose whether to take pre-orders while closed.'],
  ['sparkles', 'Upsells and substitutes', 'Choose each dish’s add-on and up to three backups in a few clicks.'],
  ['shield', 'Large-order protection', 'Hold big orders until they’re paid, with a threshold you set.'],
];

export default function Admin() {
  const [menu, setMenu] = useState(INITIAL_MENU);
  const toggle = (i) => setMenu((m) => m.map((item, j) => (j === i ? { ...item, on: !item.on } : item)));

  return (
    <section className="section dark" id="admin">
      <div className="wrap">
        <div className="section__head" data-reveal>
          <p className="eyebrow">Admin portal</p>
          <h2 className="h2">
            Run the whole front of house <em>from one dashboard.</em>
          </h2>
          <p className="lead">
            Change the menu, hours and pricing logic yourself, in seconds, with no support tickets.
            Every order from every channel lands in one live view.
          </p>
        </div>

        <div className="admin" data-reveal>
          <aside className="admin__side" aria-hidden="true">
            <span className="admin__brand">Portal</span>
            {['Orders', 'Menu', 'Upsells', 'Hours', 'Settings'].map((s, i) => (
              <span key={s} className={i === 0 ? 'is-active' : ''}>
                {s}
              </span>
            ))}
          </aside>
          <div className="admin__main">
            <div className="admin__bar">
              <h3>Live orders</h3>
              <span className="pill pill--live">
                <span className="dot-live" /> Open until 10:00 pm
              </span>
            </div>
            <div className="orders" role="table" aria-label="Sample orders">
              {ORDERS.map((o) => (
                <div key={o.no} className="orders__row" role="row">
                  <span className="orders__no" role="cell">#{o.no}</span>
                  <span className="orders__who" role="cell">
                    <b>{o.name}</b>
                    <small>{o.items}</small>
                  </span>
                  <span role="cell">
                    <span className={`src src--${o.src.toLowerCase()}`}>{o.src}</span>
                  </span>
                  <span className="orders__total" role="cell">{o.total}</span>
                  <span role="cell">
                    <span className={`status status--${o.status.toLowerCase()}`}>{o.status}</span>
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="admin__panel">
            <h3>Menu availability</h3>
            {menu.map((item, i) => (
              <label key={item.name} className="avail">
                <span>
                  <b>{item.name}</b>
                  <small>{item.on ? item.note : 'Sold out today'}</small>
                </span>
                <input type="checkbox" checked={item.on} onChange={() => toggle(i)} />
                <span className="toggle" aria-hidden="true" />
              </label>
            ))}
            <div className="admin__alert">
              <Icon name="bell" size={18} />
              <span>
                <b>Counter tablet</b>
                <small>Plays a loud alert for every new order, even when the screen is locked.</small>
              </span>
            </div>
          </div>
        </div>

        <div className="grid3">
          {FEATURES.map(([icon, title, body]) => (
            <div key={title} className="feature" data-reveal>
              <span className="icon-chip icon-chip--dark">
                <Icon name={icon} />
              </span>
              <div>
                <h3>{title}</h3>
                <p>{body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
